module.exports = __webpack_public_path__ + "img/20200515_163617.b99a7061.jpg";